import React from 'react';
import NoMatchJumbotronHeader from '../ui/NoMatchJumbotronHeader';

// Page component used as a fallback page if route isn't found.
export const NoMatch = () => (
    <div>
        <NoMatchJumbotronHeader/>
    </div>
)